import { Navigate } from 'react-router-dom';
import { useAutenticacion } from '../../contextos/authContext';

interface RutaProtegidaProps {
  children: React.ReactNode;
}

export const RutaProtegida: React.FC<RutaProtegidaProps> = ({ children }) => {
  const { estaAutenticado, verificandoSesion } = useAutenticacion();

  // 🔒 Mientras verifica, no mostramos nada (o puedes mostrar un spinner global)
  if (verificandoSesion) {
    return null;
  }

  // 🚫 Si no está autenticado, redirige a /ingresar
  if (!estaAutenticado) {
    return <Navigate to="/ingresar" replace />;
  }

  // ✅ Si está autenticado, renderiza el contenido protegido
  return <>{children}</>;
};
